import React from 'react';
import PropTypes from 'prop-types';
import Table from 'src/components/table/Table';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import UsePermission from 'src/hoc/UsePermission';

const VehicleInsurancePaymentList = (props) => {
    const viewVehicleInsurancePaymentsPermissionRemove = UsePermission({
        scope: 'flow.case_manager.vehicle_insurance_payments.remove',
    });

    const {
        payments,
        removePayment,
    } = props;

    return (
        <div className="card mt-3">
            <div className="card-body">
                <h5 className="card-title">Payments</h5>
                <Table
                    recordsPerPage={payments?.length}
                    hasRemove={viewVehicleInsurancePaymentsPermissionRemove}
                    removeClick={removePayment}
                    rowDeletedCheckPath="deleted"
                    searchData={{
                        data: payments,
                        count: payments?.length,
                        currentPage: 0,
                    }}
                    columns={{
                        payment_date: {
                            display: 'Payment Date',
                            path: 'payment_date',
                            type: Date,
                            format: DATE_TIME_FORMAT.DATE,
                        },
                        instrument_number: {
                            display: 'Instrument Number',
                            path: 'instrument_number',
                        },
                        bank_name: {
                            display: 'Bank',
                            path: 'bank_name',
                        },
                        amount: {
                            display: 'Amount',
                            path: 'amount',
                        },
                        is_paid_by_us: {
                            display: 'Is Paid by Us',
                            path: 'is_paid_by_us',
                        },
                        deletedTs: {
                            display: 'Deleted On',
                            path: 'deletedTs',
                        },
                    }}
                />
            </div>
        </div>
    );
};

VehicleInsurancePaymentList.propTypes = {
    payments: PropTypes.arrayOf({}).isRequired,
    removePayment: PropTypes.func.isRequired,
};

export default VehicleInsurancePaymentList;
